import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { Box } from "@mui/material";
import React from "react";
import CredItemModalButtons from "./CredItemModalButtons";
import TextInputField from "./TextInputField";

export default function CredItemModal(props) {
  const {
    handleClose,
    open,
    activeCredItem,
    setActiveCredItem,
    credListViewActiveCredItemIndex,
    setCredListViewActiveCredItemIndex,
    isNewCredItem,
    setIsNewCredItem,
  } = props;
  const [isEditable, setIsEditable] = React.useState(false);

  const displayCredItemFields = ["name", "website", "username", "password"];

  const clearCredItemModalData = () => {
    setIsEditable((open) => {
      return false;
    });
    setActiveCredItem((open) => {
      return { name: "", website: "", username: "", password: "" };
    });
    setCredListViewActiveCredItemIndex((open) => {
      return null;
    });
    setIsNewCredItem((open) => {
      return false;
    });
  };

  return (
    <Dialog
      onClose={handleClose}
      onTransitionExited={clearCredItemModalData}
      open={open}
      align="center"
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle align="center">
        {activeCredItem ? activeCredItem.name : ""}
      </DialogTitle>
      <Box sx={{ width: 0.95 }}>
        <ul>
          {displayCredItemFields.map((key) => (
            <li key={key}>
              <TextInputField
                displayName={key}
                name={key}
                type="text"
                value={activeCredItem[key]}
                isEditable={isEditable || isNewCredItem}
                onChange={(e) => {
                  setActiveCredItem({
                    ...activeCredItem,
                    [e.target.name]: e.target.value,
                  });
                }}
                onKeyUp={(e) => {
                  e.key === "Enter" && console.log(activeCredItem);
                }}
              />
            </li>
          ))}
        </ul>
      </Box>
      <br />
      <CredItemModalButtons
        isEditable={isEditable}
        isNewCredItem={isNewCredItem}
        setIsEditable={setIsEditable}
        activeCredItem={activeCredItem}
        credListViewActiveCredItemIndex={credListViewActiveCredItemIndex}
        handleClose={handleClose}
      />
    </Dialog>
  );
}
